export default {
  initialColorMode: "system",
  useSystemColorMode: true,
};
